<template>
    <ul v-if="menuItems.length > 0">
        <slot name="header"/>
        <li v-for="menuItem in menuItems" :key="menuItem.id" class="mm-listitem--border">
            <navigation-item-link :menu-item="menuItem" class="upcase mm-listitem__text"/>

            <menu-items-tree-mobile :menu-items="menuItem.children">
                <template #header v-if="menuItem.menu_itemable_type === 'Category'">
                    <li class="mm-listitem--border mm-listitem--header">
                        <nuxt-link :to="{ name: 'categories', params: { name: menuItem.link } }"
                                   class="upcase mm-listitem__text">
                            SHOP ALL {{ menuItem.name }}
                        </nuxt-link>
                    </li>
                </template>
            </menu-items-tree-mobile>
        </li>
    </ul>
</template>

<script>
    import NavigationItemLink from "./navigation/NavigationItemLink"

    export default{
        name: 'menu-items-tree-mobile',
        components: { NavigationItemLink },
        props: {
            menuItems: {
                type: Array,
                default: () => ({})
            }
        }
    }
</script>
